<div fxLayoutAlign="{{align}}">
  <mat-chip-listbox fxLayoutGap="10" style="margin-bottom: 10px;" >
    <mat-chip><span [ngClass]="colorChip()">{{stateLabel()}}</span></mat-chip>
  </mat-chip-listbox>
</div>
